import { supabase } from '@/lib/supabase'

export interface MonitorBranch {
  is_default?: boolean; id: string; name: string; project_ref: string; parent_project_ref: string;
  age_hours: number | null; status: string; persistent: boolean; with_data: boolean;
  reasons: string[]; critical: boolean; recommendation: 'delete' | 'check' | 'keep'; git_branch?: string | null;
}
export interface BranchProject {
  ref: string; name: string; organization_id?: string; organization_name?: string; covered: boolean; error: string | null; branches: MonitorBranch[];
}
export interface BranchReport {
  discovery?: 'organizations' | 'projects_fallback';
  organizations?: Array<{ id: string; name: string; covered: boolean; error: string | null }>; failed_call?: string; checked_at: string; projects: BranchProject[]; error: string | null;
}
export interface BranchDeleteResult { ok: boolean; error?: string; report?: BranchReport }

export const monitorBranchesApi = {
  report: async (): Promise<BranchReport | null> => {
    const { data, error } = await supabase.rpc('admin_monitor_branches')
    if (error) throw error
    return data as BranchReport | null
  },
  remove: async (project: string, branch: MonitorBranch, confirmation: string): Promise<BranchDeleteResult> => {
    const { data, error } = await supabase.functions.invoke('monitor-scan', {
      body: { action: 'branches_delete', project, branch_id: branch.id, confirmation },
    })
    if (error) {
      const response = (error as { context?: Response }).context
      const result = response ? await response.clone().json().catch(() => null) as BranchDeleteResult | null : null
      return result ?? { ok: false, error: 'request_failed' }
    }
    return data as BranchDeleteResult
  },
}
